import { useAppSelector } from "store/hooks";
import { getFullAccess, getGrade } from "store/slices/user";

import type { ContentAccess } from "utils/contentAccess";
import { graduationContentAccess, isTutoringVisible } from "utils/contentAccess";

/**
 * AIDEV-NOTE: Menu i guardy v routách musí rozhodovat stejně — kdyby menu položku
 * skrylo a routa ji pustila, přímá URL by omezení obešla. Proto jeden hook nad
 * jednou čistou funkcí, ne dvě kopie podmínky. [TD-351]
 */
export const useContentAccess = (): { graduationAccess: ContentAccess; tutoringVisible: boolean } => {
  const grade = useAppSelector(getGrade);
  const fullAccess = useAppSelector(getFullAccess);

  return {
    graduationAccess: graduationContentAccess(grade, fullAccess),
    tutoringVisible: isTutoringVisible(grade),
  };
};
